
import { mapGetters,mapActions } from 'vuex'
export default {
    props: {
        id: {
            default: '',
            type: String,
        },
        img: {
            default: 'https://cdn-wp.tefl.org/wp-content/uploads/2020/08/jake.jpg',
            type: String,
        },
        viewmore: {
          default: 'true',
          type: String
        }
    },
    data(){
        return{
            activeQuestion: 'question_1',
            answers:[],
            ready:false
        }
    },
    head() {
      if(this.ready){
        return {
            script: [{ type: 'application/ld+json', json: this.structuredData }]
        }
      }
    },
    computed: {
      ...mapGetters({
        activeModal : 'pages/getActiveModal',
      }),
      slot() {
      // const answers = []
      console.log(this.$refs.mySlot.textContent)
      const faqs =  this.$refs.mySlot.textContent.replace(/\n/g,'').split('   ')
      if (faqs[0] === ''){
        faqs.shift()
      }

      return faqs
    },
    questions() {
      const questions = []
      this.slot.forEach((qOrA) => {
        if (qOrA.includes(" Q. ")){
          const question = qOrA.replace(' Q. ','')
          questions.push(question)
        }
        else{
          const answer = qOrA.replace('A. ','')
          this.answers.push(answer)
        }
      })
      return questions
    },
    faqs() {
      const faqList = []
      this.questions.forEach((question, index) => {
        faqList.push({
          "@type": "Question",
          "name": question,
          "acceptedAnswer": {
            "@type":"Answer",
            "text": this.answers[index]
          }
        })
      })
      return faqList
    },
    structuredData() {
      return {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": this.faqs
      }
    }
    },
    methods:{
        isActive (question) {
            return this.activeQuestion === question
        },
        setActive (question) {
            this.activeQuestion = question
        },
        ...mapActions({
          updateActiveModal: 'pages/updateActiveModal', // map `this.add()` to `this.$store.commit('increment')`
        }),
        updateModal(id){
          this.updateActiveModal(id)
          console.log('Active Modal: ',this.activeModal)
        }
    },
    mounted() {
      this.ready = true
    },
    render() {
      const slot = this.$slots.default
      //  return slot.text.replace(/,/g, "")
      return slot
    },
}
